import { View, Text } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { FC, memo } from "react";
import { formatTime, type SegmentLabel } from "@src/features/schedules/utils/schedule-utils";

interface TimeLabelsProps {
  labels: SegmentLabel[];
  barHeight: number;
}

export const TimeLabels: FC<TimeLabelsProps> = memo(({ labels, barHeight }) => {
  const { theme } = useUnistyles();

  return (
    <>
      {labels.map((label, i) => {
        const boundaryY = (label.percent / 100) * barHeight;
        const labelHeight = 10;
        const padding = theme.spacing.lg;
        const top = label.position === "below" ? boundaryY + theme.spacing.xxs : boundaryY - labelHeight - padding;
        return (
          <View key={i} style={[styles.container, { top }]}>
            <View
              style={[
                styles.label,
                {
                  backgroundColor: label.isException ? (theme.colors.white[850] as string) : "transparent",
                },
              ]}
            >
              <Text textStyle="xs/regular" color={label.isException ? "black" : "text"} style={styles.labelText}>
                {formatTime(label.time.hour, label.time.minute)}
              </Text>
            </View>
          </View>
        );
      })}
    </>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    alignItems: "center",
    zIndex: 10,
  },
  label: {
    borderRadius: theme.spacing.xl,
    borderWidth: 1,
    borderColor: theme.colors.white.default,
    minWidth: 36,
    alignItems: "center",
    justifyContent: "center",
  },
  labelText: {
    fontSize: 8,
  },
}));
